import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import { countriesDATA, planArea, logisticsData, bankData } from './request';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { quillEditor } from 'vue-quill-editor'; //富文本编辑区
import quillConfig from '@/views/components/editor/quill-config.js';
import topTitle from '@/components/title';
import areaSelect from '@/components/cascader.vue';
import controlItem from './controlItem.vue';
import previewModal from '@/views/claim/demageManage/previewModal.vue';
import { statistics, control, advanceControl } from './utils';
import { uploadFile } from '../../customer/applicationManage/request';
import { cryptoDecrypt } from '@/utils/aes';
import addTableControlModel from './addTableControlModel.vue';
import { getBase64, isImage, isVideo, isPDF, isExcel, isWord } from '@/views/claim/demageManage/utils';
import tableDesignModel from './tableDesignModel.vue';
import relationModel from './relationModel.vue';
import controlAction from './components/controlAction.vue';
import { randomNumber } from '@/utils/public';
import tableControl from './components/tableControl.vue';
import signModel from './components/signModel.vue'; //签名组件
import customModel from './components/customModel.vue'; //自定义组件
import groupControl from './components/groupControl.vue'; //控件组
import singLine from './components/singLine.vue'; //单行文本
import SignatureControl from './components/SignatureControl.vue'; //签名组件--------------------
import ParagraphControl from './components/ParagraphControl.vue'; //段落组件----------fujianModer
import fujianModer from './components/fujianModer.vue'; //段落组件----------
import fjModer from './components/fjModer.vue'; //段落组件----------
const MAX_SIZE = 50; // MB
const MAX_VIDEO_SIZE = 300; // MB
import { mapState, mapMutations } from 'vuex';
export default {
  props: ['itemid', 'allForm', 'editIndex'],
  components: {
    topTitle,
    areaSelect,
    previewModal,
    controlItem,
    addTableControlModel,
    tableDesignModel,
    relationModel,
    quillEditor,
    signModel,
    tableControl,
    customModel,
    groupControl,
    singLine,
    controlAction,
    SignatureControl,
    //签名组件
    ParagraphControl,
    fujianModer,
    fjModer
  },
  data() {
    return {
      //
      optionsData: {
        optionsAA: [{
          value: 2,
          label: '每行2列'
        }, {
          value: 3,
          label: '每行3列'
        }, {
          value: 4,
          label: '每行4列'
        }, {
          value: 5,
          label: '每行5列'
        }, {
          value: 6,
          label: '每行6列'
        }, {
          value: 7,
          label: '每行7列'
        }, {
          value: 8,
          label: '每行8列'
        }, {
          value: 9,
          label: '每行9列'
        }, {
          value: 10,
          label: '每行10列'
        }],
        value: 2
      },
      hoverFileName: '',
      // 存储鼠标悬浮的文件名
      // 下拉国家数据
      currentOptions: [],
      //获取接口数据
      propsTree: {
        children: 'children',
        label: 'name',
        value: 'id'
      },
      // selectedValue: '', //单选选中数据国家
      getcountData: [],
      areaList: [],
      valuedata: [],
      //存储省市数据
      provinceDATA: [],
      //获取接口数据
      // 签名控件
      signatureIMAGE: '',
      //签名默认为空
      // 段落控件
      controlCount: 0,
      // 控件序号
      quillOption: quillConfig,
      // 定义一个全局的index作为传值 附件
      // 单选 横向 竖向
      // sortWay: 'TRANSVERSE', //默认横向展示
      // columnsPerRow: 3,
      // 结束
      selectedOption: '',
      //被选中的选项值
      showInput: false,
      //默认隐藏
      inputValue: '',
      //输入框
      formeFalse1: false,
      // 附件内容
      activeIndex: null,
      Datatemplate: [],
      //上传的文件数据
      fileListData: [],
      //上传的文件数据
      DatatemplateFalse: false,
      indexQJ: null,
      //定义文件长传的index用于传值
      isModalVisible: false,
      //文件数据
      // 日期控件
      dateTimeValue: 'date',
      selectedDate: null,
      selectedDateTime: null,
      dateFormat: 'YYYY-MM-DD',
      dateTimeFormat: 'YYYY-MM-DD HH:mm:ss',
      startTimeOption: 'unlimited',
      specificTime: null,
      relativeTime: 0,
      relativeUnit: 'days',
      visiblecustom: false,
      //下拉选择自定义
      selectedcustom: false,
      //下拉选择自定义
      formDataArray: [],
      //获取的数据 用于v-for循环数据列表
      MinMaxindex: 0,
      //每个点击项的索引值作为全局使用
      DataArray: [],
      titleInput: '',
      //表单区名称
      isSelected: false,
      //关联、下拉、编辑
      // 存储的表单数据
      formData: {},
      minWordCount: 0,
      maxWordCount: 500,
      rulesTrue: {
        //统一控件说明如下：
        // 名称设置：
        // 控件名称：单行文本框，限制为0-500个字符。
        // 默认情况下，将填入控件类型的名称。
        // 非必填。如果删除了控件名称，在控件位置上方会进行补位。如果控件名称过长，会根据页面宽度换行显示。
        controlName: [{
          required: false,
          message: this.$t('请输入') + this.$t('控件名称'),
          trigger: 'blur'
        }, {
          min: 1,
          max: 500,
          message: this.$t('长度在 1 到 500 个字符之间'),
          trigger: 'blur'
        }],
        promptText: [{
          message: this.$t('长度最多为 100 个字符'),
          trigger: 'blur'
        }],
        controlExplain: [{
          max: 100,
          message: this.$t('长度最多为 100 个字符'),
          trigger: 'blur'
        }],
        mark: [{
          required: true,
          message: this.$t('请输入标识'),
          trigger: 'blur'
        }, {
          min: 1,
          max: 50,
          message: this.$t('长度在 1 到 50 个字符之间'),
          trigger: 'blur'
        }],
        prefix: [{
          message: this.$t('请输入...'),
          trigger: 'blur'
        }, {
          min: 1,
          max: 100,
          message: this.$t('长度在 1 到 50个字符'),
          trigger: 'blur'
        }],
        suffix: [{
          message: this.$t('请输入....'),
          trigger: 'blur'
        }, {
          min: 1,
          max: 100,
          message: this.$t('长度在 1 到 100个字符'),
          trigger: 'blur'
        }],
        mark: [{
          required: true,
          message: this.$t('请输入....'),
          trigger: 'blur'
        }, {
          min: 1,
          max: 50,
          message: this.$t('长度在 1 到 100个字符'),
          trigger: 'blur'
        }],
        phoneRules: [{
          required: true,
          message: this.$t('请输入手机号'),
          trigger: 'blur'
        }, {
          pattern: /^1\d{10}$/,
          message: this.$t('手机号格式不正确'),
          trigger: 'blur'
        }],
        idCardRules: [{
          required: true,
          message: this.$t('请输入身份证号')
        }, {
          pattern: /^[1-9]\d{5}(19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[0-9Xx]$/,
          message: this.$t('身份证号格式不正确')
        }],
        emailRules: [{
          required: false,
          message: this.$t('请输入邮箱'),
          trigger: 'blur'
        }, {
          pattern: /^[a-zA-Z0-9_]{1,18}@[a-zA-Z0-9]+\.com$/,
          message: this.$t('邮箱格式不正确'),
          trigger: 'blur'
        }],
        // 文件格式验证
        fileFormat: [{
          type: 'array',
          required: false,
          message: this.$t('请选择') + this.$t('文件格式'),
          trigger: 'change'
        }],
        // // 文件大小
        fileSize: [{
          type: 'number',
          required: true,
          message: this.$t('请选择') + this.$t('文件大小'),
          trigger: 'blur'
        }],
        // //日期
        // dateType: [{required: true, message: this.$t('请选择') + this.$t('日期类型'), trigger: 'change'}]
        // 选项值文本
        name: [{
          required: true,
          message: this.$t('选项值不能为空'),
          trigger: 'blur'
        }]
      },
      defaultOption: '全部',
      subDataList: [],
      // 结束--------------------------------------------------------
      //图片需要参数
      action: uploadFile,
      uploadAccept: '',
      checkAll: false,
      indeterminate: false,
      fileDialog: false,
      previewVisible: false,
      previewSrc: '',
      previewPDF: '',
      isPDFShow: false,
      isShow: '',
      currentPreviewIndex: 0,
      statistics,
      control,
      advanceControl,
      dialogVisible: false,
      isEdit: false,
      dataForm: {
        partsType: '',
        formName: '',
        controlName: '',
        controlExplain: '',
        promptText: '',
        other: '',
        type: '',
        optionList: [],
        fileFormat: [],
        template: []
      },
      name: '',
      containerVisible: false,
      tableDesignModelVisible: false,
      relationModelVisible: false,
      relationData: [],
      relationModelIndex: 0,
      tableId: '',
      tableMark: '',
      // 关联模块相关
      isHaveRelation: false,
      selectValue: '',
      selectData: []
    };
  },
  computed: {
    ...mapState({
      controlDatas: state => state.control.controlDatas,
      groupSelected: state => state.control.groupSelected,
      activeIdx: state => state.control.activeIdx
    }),
    controlInfo() {
      return {
        1: {
          controlName: [{
            required: true,
            message: this.$t('请输入') + this.$t('控件名称'),
            trigger: 'blur'
          }]
        },
        2: {
          controlName: [{
            required: true,
            message: this.$t('请输入') + this.$t('控件名称'),
            trigger: 'blur'
          }],
          option: [{
            required: true,
            message: this.$t('请填写控件选项，不同选项用“，”隔开'),
            trigger: 'blur'
          }]
        },
        3: {
          controlName: [{
            required: true,
            message: this.$t('请输入') + this.$t('控件名称'),
            trigger: 'blur'
          }],
          type: [{
            required: true,
            message: this.$t('请选择') + this.$t('类别'),
            trigger: 'change'
          }]
        },
        4: {
          controlName: [{
            required: true,
            message: this.$t('请输入') + this.$t('控件名称'),
            trigger: 'blur'
          }],
          dateType: [{
            required: true,
            message: this.$t('请选择') + this.$t('日期类型'),
            trigger: 'change'
          }]
        },
        5: {
          controlName: [{
            required: true,
            message: this.$t('请输入') + this.$t('控件名称'),
            trigger: 'blur'
          }],
          fileFormat: [{
            type: 'array',
            required: false,
            message: this.$t('请选择') + this.$t('文件格式'),
            trigger: 'change'
          }]
        },
        6: {
          operation: [{
            required: true,
            message: this.$t('请选择') + this.$t('操作'),
            trigger: 'change'
          }]
        },
        7: {}
      };
    }
  },
  watch: {
    selectedValue(newValue) {
      // console.log('选中的值为:', newValue);
    },
    minWordCount(newMin, oldMin) {
      if (this.maxWordCount <= newMin) {
        this.maxWordCount = newMin + 1;
      }
    },
    controlDatas(val) {
      // console.log(val, '---监听controlDatas-----');
      this.formDataArray = val;
    }
  },
  created() {},
  methods: {
    // 日期事件
    timeSelectChange(item) {
      if (item.type === 'SPECIFIC_TIME' && item.dateInput) {
        item.dateInput = '';
      } else {
        item.value = '';
      }
    },
    // 表单区名称
    validateTitle(rule, value, callback) {
      if (value.length > 100) {
        callback(new Error(this.$t('表单区名称超过100个字符')));
      } else {
        callback();
      }
    },
    // 文件显示名字
    handleMouseMove(e) {
      // const fileListData = this.formDataArray.fileListData;
      // // const fileListData = this.item.fileListData; // 已上传文件的列表数据
      // const target = e.target; // 当前鼠标悬浮的元素
      // const index = Array.from(target.parentNode.childNodes).indexOf(target); // 获取当前元素在父节点中的索引
      // this.hoverFileName = fileListData[index].name; // 更新悬浮文件名
    },
    ...mapMutations({
      SET_CONTROL_DATAS: 'control/SET_CONTROL_DATAS',
      SET_GROUP_SELECTED: 'control/SET_GROUP_SELECTED',
      SET_ACTIVE_IDX: 'control/SET_ACTIVE_IDX',
      SET_ITEMID: 'control/SET_ITEMID'
    }),
    // 签名相关
    // top点击事件显示输入框
    handleOptionClick(item1, index2) {
      this.formDataArray[index2].selectedOption = item1.name;
      this.formDataArray[index2].controlValue.forEach(item => {
        if (item !== item1) {
          item.showInput = false;
          item.emptyValue = '';
        }
      });
      item1.showInput = item1.isWrite;
      item1.emptyValue = '';
    },
    // 多选控件事件 数值控制 最大值 最小值
    handleNumberLimit1Change(index) {
      if (this.formDataArray[index].numberLimit1 >= this.formDataArray[index].numberLimit2) {
        // 如果第一个输入框的值大于等于第二个输入框的值，则将第二个输入框的最小值设置为第一个输入框的值加1
        this.formDataArray[index].numberLimit2 = this.formDataArray[index].numberLimit1 + 1;
      }
    },
    handleOptionChange(item2, index2) {
      if (item2.isWrite) {
        const index = this.formDataArray[index2].selectedOptionsDX.indexOf(item2.name);
        if (index !== -1) {
          this.formDataArray[index2].controlValue.forEach(opt => {
            if (opt.name === item2.name) {
              opt.emptyValue = '';
            }
          });
        } else {
          this.formDataArray[index2].controlValue.forEach(opt => {
            if (opt.name === item2.name) {
              opt.emptyValue = null;
            }
          });
        }
      }
    },
    // 多选添加
    addOptionDX(index, index2) {
      const newOption = {
        name: '',
        isWrite: false,
        emptyValue: '',
        association: {
          type: '',
          // "or或 and且",
          association: [] // 如果为空则代表没有关联关系
        }
      };
      // 添加判断不能为空 为空提示  不能添加新的文本
      const hasEmptyValue = this.formDataArray[index2].controlValue.some(option => option.name === '');
      // 选项值重复处理
      const hasDuplicate = this.formDataArray[index2].controlValue.findIndex((option, i) => option.name === newOption.name && i !== index) !== -1;
      if (hasEmptyValue) {
        this.$message.error(this.$t('选项值不能为空'));
      } else if (hasDuplicate) {
        this.$message.error(this.$t('选项值重复'));
      } else {
        this.formDataArray[index2].controlValue.push(newOption);
        // this.options.splice(index + 1, 0, newOption);
      }
      // this.formDataArray[index2].controlValue.push(newOption);
      // this.formDataArray[index2].controlValue.splice(index + 1, 0, newOption);
    },
    moveUpDX(index, index2) {
      const option = this.controlValue[index];
      this.formDataArray[index2].controlValue.splice(index, 1);
      this.controlValue.splice(index - 1, 0, option);
    },
    moveDownDX(index, index2) {
      const option = this.formDataArray[index2].controlValue[index];
      this.formDataArray[index2].controlValue.splice(index, 1);
      this.formDataArray[index2].controlValue.splice(index + 1, 0, option);
    },
    deleteOptionDX(index, index2) {
      this.formDataArray[index2].controlValue.splice(index, 1);
    },
    // 单选控件事件
    addOptionDA(index, index1) {
      // console.log('单选事件点击增加--', index);
      const newOption = {
        name: '',
        isWrite: false,
        emptyValue: '',
        association: {
          type: '',
          // "or或 and且",
          association: [] // 如果为空则代表没有关联关系
        }
      };

      // 添加判断不能为空 为空提示  不能添加新的文本
      const hasEmptyValue = this.formDataArray[index1].controlValue.some(option => option.name === '');
      // 选项值重复处理
      const hasDuplicate = this.formDataArray[index1].controlValue.findIndex((option, i) => option.name === newOption.name && i !== index) !== -1;
      if (hasEmptyValue) {
        this.$message.error(this.$t('选项值不能为空'));
      } else if (hasDuplicate) {
        this.$message.error(this.$t('选项值重复'));
      } else {
        this.formDataArray[index1].controlValue.push(newOption);
        // this.options.splice(index + 1, 0, newOption);
      }
      // this.formDataArray[index1].controlValue.splice(index + 1, 0, newOption);
      // 是一个数组操作的语句，它使用splice方法在this.formDataArray[index1].controlValue数组中的指定位置插入一个新元素newOption。
    },
    // 上移
    moveUpDA(index, index1) {
      const option = this.formDataArray[index1].controlValue[index];
      this.formDataArray[index1].controlValue.splice(index, 1);
      this.formDataArray[index1].controlValue.splice(index - 1, 0, option);
    },
    // 下移
    moveDownDA(index, index1) {
      const option = this.formDataArray[index1].controlValue[index];
      this.formDataArray[index1].controlValue.splice(index, 1);
      this.formDataArray[index1].controlValue.splice(index + 1, 0, option);
    },
    deleteOptionDA(index, index1) {
      this.formDataArray[index1].controlValue.splice(index, 1);
    },
    // 单选结束

    // 下拉控件事件开始------------------------------------------------------
    // 是否多选事件
    MultipleShow(item, index) {
      if (item.isMultipleChoice === false) {
        // 清空单选情况下的选择值
        this.formDataArray[index].selectedValues = [];
        this.propsTree.multiple = false;
        // console.log('点击否', this.formDataArray[index].selectedValues);
      } else if (item.isMultipleChoice === true) {
        // this.selectedValues = ''; // 清空单选情况下的选择值
        this.formDataArray[index].selectedValues = [];
        this.propsTree.multiple = true;
        // console.log('点击是', this.formDataArray[index].selectedValues);
      }
    },
    //下拉国家 省市 省市区
    async customClickVue(item, index) {
      // console.log('获取点击事件的值---', item);
      // 自定义
      if (item === 'custom') {
        this.visiblecustom = true;
        this.treelist(index);
        // this.$nextTick(() => {
        //   this.visiblecustom = true; // 在下一个渲染周期中设置为true
        // });
      }
      // 职业
      if (item === 'profession') {
        this.formDataArray[index].Customvalues = [];
        this.visiblecustom = false;
      }
      // 国家
      if (item === 'country') {
        let currentOptions = await countriesDATA({});
        this.formDataArray[index].Customvalues = currentOptions;
        this.visiblecustom = false;
      }

      // 省
      if (item === 'provinceFirstLevel') {
        // this.getprovince(index);
        let currentOptions = await planArea({
          level: 1,
          type: 'noAll'
        });
        this.formDataArray[index].Customvalues = currentOptions;
        this.visiblecustom = false;
      }
      // 省市
      if (item === 'province') {
        // this.getprovinceS(index);
        let currentOptions = await planArea({
          level: 2,
          type: 'noAll'
        });
        this.formDataArray[index].Customvalues = currentOptions;
        this.visiblecustom = false;
      }
      // 省市区
      if (item === 'provinceArea') {
        // this.getprovinceArea(index);
        let currentOptions = await planArea({
          level: 3,
          type: 'noAll'
        });
        this.formDataArray[index].Customvalues = currentOptions;
        this.visiblecustom = false;
      }
      // 开户行
      if (item === 'bank') {
        let currentOptions = await bankData({
          level: 1
        });
        this.formDataArray[index].Customvalues = currentOptions;
        this.visiblecustom = false;

        // this.getbank(index);
      }
      // 物流
      if (item === 'logistics') {
        let currentOptions = await logisticsData({
          level: 1
        });
        this.formDataArray[index].Customvalues = currentOptions;
        this.visiblecustom = false;

        // this.getlogistics(index);
      }
    },
    // 下拉自定义事件
    handleOk(index) {
      this.visiblecustom = false;
      // this.formDataArray[index].type.type = '';
    },
    // 获取创建的tree数据  ---2、自定义列表数据
    treelist(data, index) {
      // 处理从子组件传递过来的树形数据
      // this.formDataArray[index].Customvalues = data;
      // console.log('子传父--2、自定义列表数据', data);
    },
    // 更新选中的值'
    handleCascaderChange(value) {
      // this.item.selectedValues = value; // 更新选中的值
      // console.log('更新选中的值', this.item.selectedValues);
    },
    // 获取国家接口数据
    async getcount(index) {
      // this.getcountData = await countriesDATA({});
      const res = await countriesDATA({});
      this.formDataArray[index].Customvalues = res;
    },
    // 获取省数据
    async getprovince() {
      const res = await planArea({
        level: 1,
        type: 'noAll'
      });
      this.formDataArray[index].Customvalues = res;
    },
    // 获取省市数据
    async getprovinceS(index) {
      // this.provinceDATA = await planArea({level: 2});
      const res = await planArea({
        level: 2,
        type: 'noAll'
      });
      this.formDataArray[index].Customvalues = res;
    },
    // 获取省市区数据
    async getprovinceArea(index) {
      // this.provinceDATA = await planArea({level: 2});
      const res = await planArea({
        level: 3,
        type: 'noAll'
      });
      this.formDataArray[index].Customvalues = res;
    },
    // 获取开户行
    async getbank(index) {
      const res = await bankData({
        level: 1
      });
      this.formDataArray[index].Customvalues = res;
    },
    // 获取物流
    async getlogistics(index) {
      const res = await logisticsData({
        level: 1
      });
      this.formDataArray[index].Customvalues = res;
    },
    // 取出 item中的值进行分割取值，取最大值、取最小值
    getMinValue(numberLimit) {
      const [minValue] = numberLimit.split(',');
      return parseInt(minValue);
    },
    getMaxValue(numberLimit) {
      const [, maxValue] = numberLimit.split(',');
      return parseInt(maxValue);
    },
    // 1、单行文本业务逻辑-----------------------开始----------------------------------------
    minMaxNav(index) {
      this.MinMaxindex = index;
      // console.log('获取每个节点的index', index);
    },
    // 单行文本 小数点位数 没有输入内容 并且失去焦点 将数据设置为默认状态

    // 附件控件逻辑-----------------------------开始-------------------------------
    clickfu(index) {
      if (!this.formDataArray[index].fileNumber.value) {
        this.formDataArray[index].fileNumber.value = 10;
      }
    },
    // 当输入框被清空时，parseInt() 函数会返回 NaN（Not a Number），
    handleInputBlur(fileNumber) {
      if (!fileNumber.value || isNaN(fileNumber.value)) {
        fileNumber.value = 10; // 设置默认值为 2 或其他合适的值
      }
    },
    formatInteger(value) {
      return value ? String(parseInt(value)) : '';
    },
    // 单行文本 小数点位数 没有输入内容 并且失去焦点 将数据设置为默认状态
    //   先检查 decimalPlaces 是否为空（falsy 值），并且不等于 0。如果满足这两个条件，则将 decimalPlaces 设置为默认值 2。
    // 通过这个修改，当清空输入框并失去焦点时，会将其值设置为默认值 2，以确保始终存在一个非空的值。
    xsdDefault1(index) {
      if (!this.formDataArray[index].decimalPlaces && this.formDataArray[index].decimalPlaces !== 0) {
        this.formDataArray[index].decimalPlaces = 2;
      }
    },
    // 单行文本 没有输入内容 并且失去焦点 将数据设置为默认状态
    zsxzDefault1(index) {
      if (!this.formDataArray[index].textMinLength) {
        this.formDataArray[index].textMinLength = 0;
      }
    },
    zsxzDefault2(index) {
      if (!this.formDataArray[index].textMaxLength) {
        this.formDataArray[index].textMaxLength = 200;
      }
    },
    //数值限制 最小 默认值
    szxzNumberMIN(index) {
      if (!this.formDataArray[index].numberMinValue) {
        this.formDataArray[index].numberMinValue = 0;
      }
    },
    //数值限制 最大  默认值
    szxzNumberMAX(index) {
      if (!this.formDataArray[index].numberMaxValue) {
        this.formDataArray[index].numberMaxValue = 40000000;
      }
    },
    updateNumberMaxValue() {
      const decimalPlaces = this.formData.decimalPlaces;
      const minValue = this.formData.numberMinValue;
      this.formData.numberMaxValue = Math.pow(10, decimalPlaces) * 40000000 + minValue;
    },
    // 单行文本业务逻辑-----------------------结束----------------------------------------

    // 多行文本业务逻辑-----------------------开始----------------------------------------
    // 多行文本--字数限制
    multilineMIN(index) {
      if (!this.formDataArray[index].minWordCount) {
        this.formDataArray[index].minWordCount = 0;
      }
    },
    // 多行文本--字数限制
    multilineMAX(index) {
      if (!this.formDataArray[index].maxWordCount) {
        this.formDataArray[index].maxWordCount = 500;
      }
    },
    // 点击显示  下拉、上移、编辑按钮
    toggleSelection(index, item, type) {
      // 提交store
      this.SET_ACTIVE_IDX(index);
      this.SET_GROUP_SELECTED(false);
      this.formDataArray[index].isSelectedShow = true;
      // 显示 下拉、上移、编辑按钮
      this.formDataArray[index].isSelected = true;

      //控件组判断
      // if (item && item.controlType === 'controlGroup' && item.isCheck == true) {
      //   this.SET_GROUP_SELECTED(true);
      // } else {
      //   this.SET_GROUP_SELECTED(false);
      // }
      this.changeFormDataArray(index);
    },
    cancelChecked() {
      this.SET_ACTIVE_IDX(-1);
      this.SET_GROUP_SELECTED(false);
      this.changeFormDataArray(-1);
      // console.log('-------tijiao,queren都会出发数据重制----------', this.activeIdx);
    },
    // 修改数据的isCheck
    changeFormDataArray(idx, type) {
      this.formDataArray.forEach((item, index) => {
        if (idx === -1) {
          var _item$control;
          // 此时取消所有选中效果
          item.isCheck = false;
          item.groupSelected = false;
          // console.log(this.groupSelected, '-----cancal----');
          (_item$control = item.control) === null || _item$control === void 0 || _item$control.forEach(items => {
            items.isCheck = false;
            item.groupSelected = false;
          });
        } else {
          console.log(this.groupSelected, type);
          // 非控件组
          if (idx === index) {
            item.isCheck = true;
            // item.control?.forEach(items => {
            //   items.isCheck = false;
            //   items.groupSelected = false;
            // });
          } else {
            var _item$control2;
            item.isCheck = false;
            item.groupSelected = false;
            (_item$control2 = item.control) === null || _item$control2 === void 0 || _item$control2.forEach(items => {
              items.isCheck = false;
              items.groupSelected = false;
            });
          }
          // if (item.control) {
          //   console.log('------非控件组点击是否会有control-----')
          //   item.control.forEach(items => {
          //     items.isCheck = false;
          //   });
          // }
        }
      });
      // this.formDataArray = JSON.parse(JSON.stringify(this.formDataArray));
      this.SET_CONTROL_DATAS(this.formDataArray);
      console.log(this.formDataArray, '-----外层点击选中-----');
    },
    // 编辑按钮--打开内容输入内容
    formeClick(index, type) {
      this.activeIndex = index;
      console.log('编辑按钮', type, this.activeIndex);
      // console.log('编辑点击事件', item, index);
      if (type === 'table') {
        //表格控件的编辑特殊处理
        this.tableId = this.formDataArray[index].containerTemplateId;
        if (this.tableId !== -1) {
          let obj = {
            type: 'table',
            tableType: 'increment',
            tableUsage: 'control',
            id: this.tableId,
            mark: this.formDataArray[index].mark
          };
          sessionStorage.setItem('tableInitInfo', JSON.stringify(obj));
          this.tableDesignModelVisible = true;
        } else {
          this.tableMark = this.formDataArray[index].mark;
          this.containerVisible = true;
        }
      } else {
        this.formDataArray[index].editing = !this.formDataArray[index].editing;
      }
    },
    // 关闭事件
    formeClase(index) {
      this.formDataArray[index].editing = false;
    },
    //  复制
    copyControl(index) {
      // this.itemid获取id
      // 假设审核流id为123，节点id为456，时间戳为1630218456789，控件序号为1
      const auditFlowId = this.itemid; //审核流id
      const nodeId = index; //选中index
      const controlIndexPadded = '0000'; //节点id
      //  const controlId = `d.${auditFlowId}${nodeId}control${}${controlIndexPadded}`;
      const controlId = `d.${auditFlowId}control${controlIndexPadded}${nodeId}`;
      this.formDataArray[index].mark = controlId;
      const msg = this.formDataArray[index].mark;
      const save = function (e) {
        e.clipboardData.setData('text/plain', msg);
        e.preventDefault(); // 阻止默认行为
      };
      const once = {
        once: true
      };
      document.addEventListener('copy', save, once); // 添加一个copy事件,当触发时执行一次,执行完删除
      document.execCommand('copy'); // 执行copy方法
      this.$message.success(this.$t('复制成功'));
    },
    // 关联控件
    relationClick(index) {
      this.relationModelVisible = true;
      this.relationModelIndex = index;
      this.relationModelData = this.formDataArray;
      let relationArr = [];
      this.formDataArray.forEach((item, index1) => {
        console.log(item);
        console.log(item.partsType);
        if (['singleChoice', 'multipleChoice', 'dropDown'].indexOf(item.partsType) != -1 && index1 < index) {
          relationArr.push(item);
        }
      });
      this.relationData = relationArr;
    },
    // 下拉选择
    addSubData(index) {
      if (this.subDataList.length >= 5) {
        this.$message.warning(this.$t('添加级数最多支持5级！'));
        return;
      }
      const newSubData = {
        value: '',
        identifier: ''
      };
      if (typeof index === 'number') {
        this.subDataList.splice(index + 1, 0, newSubData);
      } else {
        this.subDataList.push(newSubData);
      }
    },
    editSubData(subData) {
      // 编辑逻辑
    },
    deleteSubData(index) {
      if (confirm(this.$t('确认删除数据吗？'))) {
        this.subDataList.splice(index, 1);
      }
    },
    // 提交
    submitForm() {
      this.$emit('tabulate-Data', this.formDataArray);
      this.SET_GROUP_SELECTED(false);
      this.changeFormDataArray(-1);
      // console.log('获取表单中的数据---------', this.formDataArray);
      // this.dialogVisible = false;
    },
    // 重置
    resetForm(formData) {
      this.$refs[formData].resetFields();
    },
    // 结束-------------------
    // 初始化数据--父级调用
    init(arr) {
      this.isEdit = false;
      let editArr = [];
      this.titleInput = arr.formName || '';
      arr && arr.form && arr.form.forEach(controlItem => {
        if (controlItem.controlType === 'controlGroup') {
          editArr.push(JSON.parse(JSON.stringify(controlItem)));
        } else {
          editArr.push(JSON.parse(JSON.stringify(controlItem.control)));
        }
      });
      // console.log('获取的数据', editArr);
      this.formDataArray = editArr;
      //提交store
      this.SET_CONTROL_DATAS(this.formDataArray);
      this.dialogVisible = true;
    },
    // 统计控件--赔付控件--估损控件
    controlItemFunC(val, index) {
      // this.formDataArray.push({...val});

      const auditFlowId = this.itemid; //审核流id
      const nodeId = index; //选中index
      const randomNum = Math.floor(Math.random() * 10000); //生成一个四位的随机数
      const controlId = `d.${auditFlowId}${'_'}control${randomNum}${nodeId}`;

      // 获取点击事件中的值  将选中的控件添加到右侧表单显示区域
      const clonedVal = JSON.parse(JSON.stringify(val));
      clonedVal.mark = controlId; // 将 controlId 赋值给 clonedVal.mark
      this.formDataArray.push(clonedVal);
      //提交store
      this.SET_CONTROL_DATAS(this.formDataArray);
    },
    // 左侧点击事件-----
    clickPlusitem(val, index) {
      // 获取数据获取 每个控件的数据
      this.isEdit = true;
      let mark = '';
      if (val.partsType == 'table') {
        mark = this.generateTableMark();
      } else {
        mark = this.generationMark();
      }
      const auditFlowId = this.itemid; //审核流id
      const nodeId = index; //选中index
      const randomNum = Math.floor(Math.random() * 10000); //生成一个四位的随机数
      const controlId = `d.${auditFlowId}${'_'}control${randomNum}${nodeId}`;
      // console.log(this.groupSelected, val, '-------');
      //选中控件组
      if (this.groupSelected && val.controlType !== 'controlGroup') {
        if (!this.formDataArray[this.activeIdx].control) {
          this.formDataArray[this.activeIdx].control = [];
        }
        // 插入控件时设置父级的为选中状态
        val.groupSelected = true;
        val.mark = mark;
        this.formDataArray[this.activeIdx].control.push(val);
        this.formDataArray = JSON.parse(JSON.stringify(this.formDataArray));

        //提交store
        this.SET_CONTROL_DATAS(JSON.parse(JSON.stringify(this.formDataArray)));
      } else {
        const clonedVal = JSON.parse(JSON.stringify(val));
        clonedVal.mark = mark;
        this.formDataArray.push(clonedVal);
        //提交store
        this.SET_CONTROL_DATAS(JSON.parse(JSON.stringify(this.formDataArray)));
      }
      this.$nextTick(() => {
        //添加控件后滑动到底部
        let scrollHeight = this.$refs['rightBox'].scrollHeight;
        this.$refs['rightBox'].scrollTop = scrollHeight;
      });
    },
    generateTableMark() {
      let dataTime = new Date().getTime();
      return 'table_' + dataTime;
    },
    generationMark() {
      const auditFlowId = this.itemid; //审核流id
      let time = new Date().getTime();
      const controlIndexPadded = String(time).slice(-4); //节点id
      const controlId = `d.${auditFlowId}${'_'}control${'_'}${controlIndexPadded}${randomNumber(2)}`;
      console.log(controlId, controlIndexPadded, 'controlId');
      return controlId;
    },
    // 是否必填
    ChangeFun() {
      // this.formDataArray[index].isRequired = false;
      // if (this.formDataArray[index].isRequired) {
      //   this.checked = true;
      // } else {
      //   this.checked = false;
      // }
    },
    // resetForm() {
    //   this.isEdit = false;
    //   this.checked = false;
    //   this.indeterminate = false;
    //   this.checkAll = false;
    //   // this.dataGroupForm = {};
    //   if (this.controlType == 'control') {
    //     this.dataForm = {
    //       partsType: '',
    //       formName: '',
    //       controlName: '',
    //       controlExplain: '',
    //       promptText: '',
    //       other: '',
    //       type: '',
    //       optionList: [],
    //       fileFormat: [],
    //       template: []
    //     };
    //   } else {
    //     this.dataGroupForm = {};
    //   }
    //   // console.log(this.dataForm);
    // },
    // 模板预览打开
    openModal() {
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    // 单选
    onChangeFormat(index) {
      this.toChangeUploadAccept(this.formDataArray[index].fileFormat);
    },
    // 结束
    // 设置上传文件限制格式
    toChangeUploadAccept(data) {
      // console.log(data, '设置上传文件限制格式');
      if (data.length) {
        data = data.map(i => '.' + i);
        this.uploadAccept = data.join(',');
      } else {
        this.uploadAccept = 'image/*';
      }
    },
    isFileSizeValid(file, maxSize) {
      return file.size / 1024 / 1024 < maxSize;
    },
    // 文件上传逻辑
    clickPlusTWO(index) {
      this.indexQJ = index;
      // 文件的类型的数据
      if (this.formDataArray[index].fileFormat.length == 0) {
        this.$message.error(this.$t('请选择文件格式'));
        return;
      }
    },
    changeUploadTwo({
      file,
      fileList
    }) {
      // 定义一个全局的index
      const index = this.indexQJ;
      // if (this.formDataArray[index].fileFormat.length == 0) {
      //   this.$message.error(this.$t('请选择文件格式'));
      //   return;
      // }
      const isVideoFile = isVideo(file.name);
      const maxSize = isVideoFile ? MAX_VIDEO_SIZE : MAX_SIZE;
      if (!this.isFileSizeValid(file, maxSize)) {
        const errorMessage = this.$t(isVideoFile ? '视频最大不超300M' : '文件最大不超50M');
        this.$message.error(errorMessage);
        return;
      }
      const fileType = file.name.substring(file.name.lastIndexOf('.')).substring(1);
      // 文件类型
      if (!this.formDataArray[index].fileFormat.includes(fileType)) {
        this.$message.error(this.$t('文件格式错误'));
        return;
      }
      // 文件列表
      this.formDataArray[index].fileListData = fileList.map(item => {
        if (item.response && item.response.code === 200 && item.status === 'done') {
          item.url = process.env.NODE_ENV === 'production' ? cryptoDecrypt(item.response.data).fileTempUrl : item.response.data.fileTempUrl;
          // 将文件URL添加到templateUrl变量中
          this.formDataArray[index].templateUrl += item.url + ',';
        }
        let obj = {
          uid: item.uid,
          name: item.name,
          status: item.status,
          url: item.url
        };
        return obj;
      });
      // 移除最后一个逗号
      this.formDataArray[index].templateUrl = this.formDataArray[index].templateUrl.slice(0, -1);
      this.showActionButtons = true;
    },
    // async handlePreview(file) {
    //   this.isShow = '';
    //   if (isImage(file.name)) {
    //     this.isShow = 'image';
    //   }
    //   if (isVideo(file.name)) {
    //     this.isShow = 'video';
    //   }
    //   this.isPDFShow = isPDF(file.name);
    //   if (!file.url && !file.preview) {
    //     file.preview = await getBase64(file.originFileObj);
    //   }
    //   if (this.isShow === 'image' || this.isShow === 'video') {
    //     this.previewSrc = file.url || file.preview;
    //     this.currentPreviewIndex = this.dataForm.template.indexOf(file);
    //   } else if (this.isPDFShow) {
    //     this.previewPDF = file.url || file.response.data.fileTempUrl;
    //     window.open(this.previewPDF);
    //     return;
    //   } else {
    //     window.open(file.url || file.response.data.fileTempUrl);
    //     return;
    //   }
    //   this.previewVisible = true;
    // },

    async handlePreview(file, fileList) {
      this.isShow = '';
      if (isImage(file.name)) {
        this.isShow = 'image';
      }
      if (isVideo(file.name)) {
        this.isShow = 'video';
      }
      if (isExcel(file.name)) {
        const urlid = 'https://view.officeapps.live.com/op/view.aspx?src=';
        this.previewXLSX = urlid + file.url;
        window.open(this.previewXLSX);
      }
      // doc格式打不开
      if (isWord(file.name)) {
        const urlid = 'https://view.officeapps.live.com/op/view.aspx?src=';
        this.previewDocx = urlid + file.url;
        window.open(this.previewDocx);
      }
      this.isPDFShow = isPDF(file.name);
      this.isxlsxShow = isExcel(file.name);
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      if (this.isShow === 'image' || this.isShow === 'video') {
        this.previewSrc = file.url || file.preview;

        // this.currentPreviewIndex = this.formDataArray[this.index].templateUrl.indexOf(file);
      } else if (this.isPDFShow) {
        this.previewPDF = file.url || file.response.data.fileTempUrl;
        window.open(this.previewPDF);
        return;
      } else if (this.isxlsxShow) {
        this.previewXLSX = file.url || file.response.data.fileTempUrl;
        window.open(this.previewXLSX);
        return;
      } else {
        window.open(file.url || file.response.data.fileTempUrl);
        return;
      }
      this.previewVisible = true;
    },
    // 附件上传新建
    beforeUpload(file) {
      const index = this.indexQJ;
      if (this.formDataArray[index].fileFormat.length < 0) {
        this.$message.error('请选择文件格式');
        return;
      }
      const extension = file.name.split('.').pop().toLowerCase();
      // "fileFormat": "文件格式：Word Xlsx xls JPG mov jpeg mp4 PDF BMP docx doc rm rmvb avi jpg
      const isValidType = this.formDataArray[index].fileFormat.includes(extension);
      if (!isValidType) {
        this.$message.error(this.$t('无效的文件格式'));
      }
      const isValidSize = file.size / (this.formDataArray[index].fileSize.type === 'MB' ? 1024 * 1024 : 1024) < this.formDataArray[index].fileSize.size;
      if (!isValidSize) {
        this.$message.error(this.$t('文件大小超过限制'));
      }
      return isValidType && isValidSize;
    },
    // 确认
    handleSure() {
      // if (this.controlList.length == 0) {
      //   return this.$message.error('请编辑再保存!');
      // }
      let validateStatus = {
        status: true,
        message: ''
      };

      // --------------------附件校验
      let hasEmptyFileFormat = false;
      this.formDataArray.some(item => {
        if (item.partsType === 'enclosure' && item.fileFormat.length === 0) {
          this.$message.destroy();
          this.$message.error(this.$t('至少添加一个文件格式'));
          hasEmptyFileFormat = true;
          return true; // 终止循环
        }
      });
      if (hasEmptyFileFormat) {
        return; // 停止后续操作
      }
      if (this.formDataArray.length === 0) {
        this.$message.destroy();
        this.$message.error(this.$t('至少添加一个控件'));
        return;
      }
      if (!this.titleInput) {
        this.$message.destroy();
        this.$message.error(this.$t('请输入表单名称'));
        return;
      }
      this.formDataArray.forEach(item => {
        if (item.partsType === 'table' && item.containerTemplateId === -1) {
          validateStatus.status = false;
          validateStatus.message = this.$t('存在表格未进行设置，请设置后再保存');
        } else if (item.controlType === 'controlGroup' && item.control.length === 0) {
          validateStatus.status = false;
          validateStatus.message = this.$t('控件组至少添加一个控件');
        }
      });
      if (!validateStatus.status) {
        this.$message.error(validateStatus.message);
        return;
      }
      let commonName = this.allForm.filter(item => {
        return this.titleInput === item.formName;
      });
      if (this.editIndex !== -1 && (commonName === null || commonName === void 0 ? void 0 : commonName.length) > 1 || this.editIndex === -1 && (commonName === null || commonName === void 0 ? void 0 : commonName.length) > 0) {
        this.$message.error(this.$t('表单名称重复'));
        return;
      }
      this.SET_ACTIVE_IDX(-1);
      this.SET_GROUP_SELECTED(false);
      this.changeFormDataArray(-1);
      console.log(this.formDataArray, '--------updataformDataArray啊--------');
      // let controlInfo = JSON.parse(JSON.stringify(this.formDataArray));

      let controlInfo = this.formDataArray.map(item => {
        if (item.editing === true) {
          item.editing = false;
        }
        if (item.controlType === 'controlGroup') {
          // // 控件组附件校验
          // let hasEmptyFileFormat = false;
          // const navtype = item.control;
          // console.log('获取控件组数据----3333--------------', navtype);

          // navtype.some(innerItem => {
          //   // 修改变量名为innerItem
          //   if (innerItem.partsType === 'enclosure' && innerItem.fileFormat.length === 0) {
          //     this.$message.destroy();
          //     this.$message.error(this.$t('控件组中-附件-至少添加一个文件格式'));
          //     hasEmptyFileFormat = true;
          //     return true; // 终止循环
          //   }
          // });
          // if (hasEmptyFileFormat) {
          //   return null; // 停止后续操作
          // }
          let obj = {
            controlType: 'controlGroup',
            controlName: item.controlName,
            controlExplain: item.controlExplain,
            is_show: false,
            //是否显示该控件 true是  false否
            mark: item.mark,
            other: true,
            control: item.control,
            association: item.association
          };
          return obj;
        } else {
          //控件
          let obj = {
            controlType: 'control',
            control: JSON.parse(JSON.stringify(item))
          };
          return obj;
        }
      });
      let data = {
        formName: this.titleInput,
        form: controlInfo
      };
      console.log(controlInfo, '------要传输的data-------');
      this.$emit('controlOk', data);
      // this.$emit('controlOk', this.controlList);
      this.$emit('cancel');
    },
    // 取消-关闭外层弹框
    modalClose() {
      this.SET_GROUP_SELECTED(false);
      this.changeFormDataArray(-1);
      this.$emit('cancel', false);
    },
    openDesign() {
      this.tableDesignModelVisible = true;
    },
    saveTableData(res) {
      this.formDataArray[this.activeIndex]['containerTemplateId'] = res.id;
      this.formDataArray[this.activeIndex]['containerTemplateInfo'] = JSON.stringify(res);
    },
    // 查看当前控件是否有关联关系
    checkRelation() {
      console.log('newEditModel checkRelation 日志 START');
      console.log(this.formDataArray);
      this.formDataArray.forEach(item => {
        if (['singleChoice', 'multipleChoice'].indexOf(item.partsType) !== -1) {
          item.controlValue.forEach(item1 => {
            if (item1.association.association.length > 0) {
              this.isHaveRelation = true;
            }
          });
        } else if (item.partsType === 'custom') {
          // TODO 查看下拉控件中是否有当前控件的关联关系
        }
      });
      console.log('newEditModel checkRelation 日志 END');
    },
    // 清除关联关系
    clearRelationData() {
      this.formDataArray.forEach(item => {
        if (['singleChoice', 'multipleChoice'].indexOf(item.partsType) !== -1) {
          item.controlValue.forEach(item1 => {
            if (item1.association.association.length > 0) {
              item1.association.association = [];
            }
          });
        } else if (item.partsType === 'custom') {
          // TODO 下拉控件 清除关联关系
        }
      });

      // 更新当前控件的is_show
      this.formDataArray[this.relationModelIndex].is_show = true;
      console.log(this.formDataArray);
      this.relationData = [];
      this.selectValue = $t('请选择要关联的控件');
      this.selectData = [];
      this.isHaveRelation = false;
    }
  }
};